import { fg } from '@atlaskit/platform-feature-flags';
import coinflip from '../../../../coinflip';
import checkFiberWithinComponent from './check-fiber-within-component';
import findFiberWithCache from './find-fiber-with-cache';
import findReactFiber from './find-react-fiber';
var DEFAULT_MAX_LEVEL = 20;

// Cache cleanup
var callCount = 0;
var CLEANUP_THRESHOLD = 50;
function maybeCleanup(resultCache) {
  callCount++;
  if (callCount >= CLEANUP_THRESHOLD && coinflip(0.3)) {
    cleanupCaches(resultCache);
  }
}
export function cleanupCaches(resultCache) {
  resultCache = new WeakMap();
  callCount = 0;
}
export default function checkWithinComponent(node, targetComponentName, resultCache) {
  maybeCleanup(resultCache);
  if (resultCache.has(node)) {
    var _resultCache$get;
    return {
      isWithin: (_resultCache$get = resultCache.get(node)) !== null && _resultCache$get !== void 0 ? _resultCache$get : false
    };
  }
  var fiber = null;
  var checkedNodes = [];
  if (fg('platform_ufo_handle_non_react_element_for_3p')) {
    fiber = findFiberWithCache(node, DEFAULT_MAX_LEVEL, checkedNodes);
  } else {
    fiber = findReactFiber(node);
  }
  if (!fiber) {
    if (fg('platform_ufo_handle_non_react_element_for_3p')) {
      checkedNodes.forEach(function (checkedNode) {
        resultCache.set(checkedNode, false);
      });
    }
    return {
      isWithin: false
    };
  }
  var isWithin = checkFiberWithinComponent(fiber, targetComponentName, DEFAULT_MAX_LEVEL);
  if (fg('platform_ufo_handle_non_react_element_for_3p')) {
    checkedNodes.forEach(function (checkedNode) {
      resultCache.set(checkedNode, isWithin);
    });
  }
  return {
    isWithin: isWithin
  };
}